export const noticeContent = String.raw`
## {center}Origin Beyond
{br:70}
게임프리크 社의 〈포켓몬스터〉 시리즈 기반
{br}
![notice](/img/notice/notice1.png =800)
{br}
운영진은 공지사항 미숙지로 발생하는 모든 불이익을 책임지지 않습니다.
본 문서를 비롯하여 총괄계로 업로드되는 모든 게시물은 공지에 해당하오니 정독해 주시기 바랍니다.
{br}
![manage](/img/notice/notice_managetime.png =300)
![story](/img/notice/notice_storytime.png =300)
 {br:20}
& 질문 접수 [🔗](https://open.kakao.com/o/sQ89e1xi)

 {br:30}

## 통합 공지사항

& 커뮤니티 ==‘포켓몬스터 오리진 비욘드’==은 게임프리크 社의 〈포켓몬스터〉 게임 시리즈를 기반하여 애니메이션 시리즈의 일부 설정과 창작 설정이 더해진 마스토돈 커뮤니티입니다.
** 모든 러너 분들의 원작 숙지를 가정하여 세부 설정에 대한 안내는 제공하지 않습니다.
** 게임 시스템을 차용하고 있어〈포켓몬스터〉게임 시리즈를 구매한 분에 한하여 신청서 접수를 받고 있습니다. 

& 본 커뮤니티의 운영진은 여유롭고 가벼운 운영과 러닝을 지향하고 있습니다. 
** 운영진 전원 별도의 생업을 두고 있어 운영 시간 내에 접수된 문의에 즉각적인 응대가 어려울 수 있는  점 양해 부탁드립니다.

& ==2026년 기준 04년생== 이상인 예비 러너 분들로부터 신청서를 접수받습니다. 합격자 발표 이후 나이 속임이 밝혀질 경우 즉시 제명됩니다.

& 약 ==4개월의 러닝 기간==을 예정하고 있습니다. 성장은 예정되어있지 않으며, 리뉴얼 및 휴식 기간이 존재합니다.
** 3개월(체육관, 콘테스트 및 육성 + 3일의 리뉴얼 및 휴식 기간) -1개월(레이드) 가 예정되어 있으며 레이드는 포지션 비율 및 캐릭터 성장 상태에 따라 난이도와 밸런스가 조정되므로, 중도 하차는 지양해 주시기 바랍니다. 예비 러너분들께서는 전체 일정을 충분히 고려하신 후 신청서를 제출해 주시기 바랍니다.

& 러닝 인원은 공개·비공개 MPC를 포함하여 ==최소 28인에서 최대 30인==을 예정하고 있습니다. 
** 첫 커뮤 · 첫 트위터 커뮤니티 신청은 접수받지 않습니다. 첫 포켓몬스터 기반 혹은 첫 레이드 커뮤니티 등의 경우는 가능합니다. 
** 합격자 발표 이후 마스토돈 이용에 관한 가이드를 전달할 예정입니다. 

& 체육관 도전 및 배틀 참여는 필수가 아니며, 배틀에 익숙하지 않은 분들도 참여하실 수 있도록 난이도가 조정될 예정입니다. 다만, 배틀은 본 커뮤니티의 주요 콘텐츠로, 참여하지 않을 경우 일부 콘텐츠 이용에 있어 소외감을 느끼실 수 있습니다.


## 러닝 가이드
& 특정 구간에 한해 러너 캐릭터들의 선택이 중요하게 여겨지는 스토리를 예정하고 있습니다. 따라서 ==러너 전원의 스토리 참여를 전제==로 합니다.
** 스토리 불참시 당일 19시까지 연락 부탁드립니다. 
** 예) 1월 1일 스토리 불참의 경우: ~1월 1일 19:00
** 레이드 불참시 하루 전까지 연락 부탁드립니다. 단, 불가피한 사정의 발생 시 당일 19시까지 연락이 가능합니다. 
** 예) 1월 2일 레이드 불참의 경우: ~1월 1일 23:59 / 당일 사정 발생 시: ~1월 2일 19:00

& 활동 기준은 다음과 같습니다.
& 최소 활동량 기준: 72시간 이내에 타 캐릭터 3인과의 최소 2번의 멘션 대화. (퍼블릭, 상점 등 시스템 사용 제외)
& 일정 및 개인 사정 등으로 특정 기간 러닝이 어려운 경우 ==휴식계 사용==을 권장합니다. 러닝 내 최대 4회, 각 4일까지 가능합니다. 
** 휴식계 사용 시 해당 캐릭터의 독감으로 인한 병원 입원등의 자유로운 설정이 가능합니다. 이는 원활한 RP를 위한 부가 설정이며 별도의 공지가 게시되지 않습니다. 

& 종류를 불문하고 모든 편파를 금지합니다. 편파는 운영진의 모니터링으로 발각될 수 있는 부분임을 숙지해 주시기 바랍니다. 편파 관련 건의는 운영 시간과 별개로 접수가 가능합니다.
& 러닝 중 건의사항은 마스토돈 내 총괄계정 DM으로 접수합니다. X(구 트위터) 계정을 통한 외부에서의 문서 건의와 합의되지 않은 공론화 등에 일절 응대하지 않으며 러너 간 분쟁에 운영진이 개입하지 않습니다. 
& 러닝 중 발생하는 모든 조율 사항은 스토리 계정을 포함한 DM으로 진행해 주시기 바랍니다.
& 경고가 3회 누적될 경우 이유룰 불문하고 제명 처리됩니다. 주의 2회는 경고 1회의 효력을 갖습니다.

### 금지사항 
 * (적발 시 경고 1회) 
& 공개계정으로의 러닝 타래 작성
& 바이오를 통한 대화 (ex 위치 대화)
& OO조 형성 / 전신 맞춤
& 자율 참여 시스템의 참여 강요 및 시스템의 악의적인 활용 등 
& 그외 자캐 커뮤니티에서 비매너로 분류되는 행위 전반
& 메타발언
& 초성체(ㅋㅋㅋ, ㅎㅎㅎ, ㅠㅠㅠ …) 또는 이모티콘 (💧💦…)
& 캐릭터가 알 수 없는 사항에 대한 언급 
& TRPG 용어, oO(생각 말풍선) / 사념대화
& 전설/울트라비스트/패러독스 및 그에 준하는 포켓몬 및 원작 캐릭터의 직접적인 언급 
& 작품 내 실제 나오는 용어가 아닌 비공식 용어
& ^^배틀 오리진/비욘드 난이도 관련 비교 발언^^

### 사용 가능 용어
& 랭크
& 레벨
& 특성
& 급소율 및 풀죽음과 같은 기술 부가효과 확률
& 약점으로 인한 배수계산
& 기술의 물리 / 특수 / 변화 / PP / 위력

### 메타 분류 용어
& 노력치
& 종족값/개체값
& 자속보정
& 이로치
& 결정력
& 교배/ 알까기
& 전포/환포와 같은 줄임말
** EX) 내 포켓몬에게 S252를 투자했어  (X) / 내 포켓몬은 252번의 스피드 훈련을 했어 (O)
** 내 포켓몬은 특수 종족값이 135야  (X)  / 내 포켓몬은 특수 공격에 강한 포켓몬이야.  (O) 

### 적발시 제명 사항
& 별도 조율 없이 72시간 이상 미접속 혹은 2회 이상 필참 이벤트 불참
& 캐릭터 계정 간 1:1 DM
& 타 캐릭터의 설정 도용
& 커뮤니티 수위를 넘어가거나 공지사항을 위반하는 행위 
& 오너 계정에서 타 캐릭터 및 커뮤니티 비방
& 엔딩 이전 커뮤니티 외적 교류 
& 러닝 중 고백
& 최초 신청서 제출 시 작성하지 않은 소수 합격 요소를 조율 없이 추가
& 신청서 대필 및 AI를 사용한 신청서 작성
& 구매인증 이미지 조작

## 캐릭터 가이드
& 조기엔딩을 포함하여 커뮤니티 및 TRPG의 엔딩을 본지 2년 이상 지난 캐릭터의 재활용이 가능합니다. 
& 타 커뮤니티에서 제명된 캐릭터 재활용을 금지합니다.
& 캐릭터는 모든 서사와 관계가 정리되어야 합니다.
& 연고 캐릭터 설정을 금지합니다. 
& 러닝 캐릭터들은 ==한국기준 12세~19세 영운지방 출신의 ‘미성년자’ 초보 트레이너==입니다.
& 캐릭터들은 은목 박사가 주도하는 트레이너 육성 캠프에 자의적이든 타의적이든 지원 후 선발되어 박사의 연구를 돕는 여행을 시작합니다.
& 캠프는 트레이너 육성을 목적으로 개최되었지만 배틀참가 및 리그 도전이 강제되지는 않습니다.
& 첫 번째로 함께할 포켓몬을 ==‘파트너 포켓몬’==으로 지칭하며 전부터 함께해온 포켓몬일 수도, 박사로부터 새롭게 받는 스타팅 포켓몬일 수도 있습니다. 파트너 포켓몬은 놓아주기 및 교환이 불가능하며 레이드에 참여하는 포켓몬은 파트너 포켓몬으로 고정됩니다.
** ==기존 포켓몬의 경우 친밀도는 최대 160==까지 자유롭게 설정 가능하며, 박사에게 지급받은 ==스타팅 포켓몬은 친밀도 50==으로 고정됩니다. 후에 스타팅 포켓몬 선택 러너 한정으로 친밀도 도구가 지급될 예정입니다. 
** 본 커뮤니티에서는 ==파트너 포켓몬의 메가진화가 필수사항이며, 창작 메가진화 설정 또한 가능==합니다.
** 메가진화 조건에 따라 ==특정 주차까지 최종 진화를 이루지 못한 파트너 포켓몬은 스토리 진행 중 진화가 이루어질 수 있습니다.== 해당 내용은 사전에 공지를 통해 안내드릴 예정입니다.

### 파트너 포켓몬
![partnerpkm](/img/notice/partner.png =600)
{br}
### 합격 관련 요소
![minorsector](/img/notice/minor.png =600)


%% ⓒ2026 · 포켓몬스터 오리진 비욘드`;

export const systemContent = String.raw`

## 모험
### 레포트작성
& 커뮤 내 일일 ‘출석’ 시스템으로 홈페이지 내 레포트 작성을 클릭하면 완료되어 용돈 및 경험치가 지급됩니다.
### 탐험
& 1일 10회 지역을 탐색해 야생 포켓몬 조우 및 도구 및 재료를 수집할 수 있습니다.
& 홈페이지로 진행되며 일일 탐험횟수 소진시 경험치가 지급됩니다.

### 야생 포켓몬 포획
& 야생포켓몬과의 배틀은 없으며 몬스터볼을 사용하여 ‘포획’이 가능합니다.
& 색이 다른 포켓몬이 확률적으로 등장하며, 조우하지 못한 경우에도 포획 후 봇계로 작성한 로그 툿링크를 홈페이지 내 문의게시판에 업로드 시 색이 다른 설정을 적용할 수 있습니다.
& 성별, 크기, 특성, 기술, 레벨은 랜덤으로 결정됩니다.
& 파트너 포켓몬 제외 소지 포켓몬은 최대 18마리까지 가능합니다.
& 포획한 포켓몬은 러너 간 합의하에 교환이 가능합니다.
& 메타몽 및 스타팅 포켓몬은 야생에 출몰하지 않습니다.

### 요리
& 커뮤니티 활동으로 얻은 재료를 조합해 요리할 수 있습니다.
& 1~3개의 재료를 사용하며 성공/실패 여부와 관계없이 재료는 소모됩니다
& 판매가 가능하며 일부 요리는 포켓몬의 노력치, 친밀도, 컨디션을 상승시킵니다.

### 피크닉 캠핑
& 본작의 피크닉, 포켓몬캠프와 유사하며 주 1회 1인 또는 2인으로 1인당 최대 6마리의 포켓몬과 함께 마스토돈 내 캠핑 계정을 통해 자동 진행됩니다. 
& 참여 시 경험치, 참여 포켓몬의 친밀도가 상승되며, 확률적으로 도구 획득이 가능합니다.
& 낮은 확률로 ???이 획득 가능합니다.
### 사이드 퀘스트
& 특정 기간동안 열리는 퀘스트 존재합니다. 퀘스트 완료시 보상 획득 가능하며 일부 퀘스트는 NPC혹은 러너와 관련된 사이드 스토리가 해금됩니다. 
### 타이틀
& 특정 조건 달성 시 타이틀과 보상을 지급합니다.
& 달성 조건은 별도로 공개되지 않습니다.

## 육성
9세대를 기준으로 하며 미입국 포켓몬은 최신 입국 세대를 기준으로 합니다. 자세한 정보는 해당 사이트를 참고 바랍니다. [🔗](https://pokemon.fandom.com/)

### 레벨업
& 배틀, 콘테스트에서 활용됩니다.
& 탐험/캠핑/출석/이벤트,스토리 참여 등으로 획득한 경험치 혹은 이상한 사탕 등의 도구를 통해 포켓몬의 레벨을 상승시킬 수 있습니다.
& 포켓몬의 레벨이 높아질수록 요구되는 경험치량이 증가합니다.
& 파트너 포켓몬의 레벨은 주차에 따라 자동으로 레벨이 상승됩니다.


### 진화
& 조건 충족 시 홈페이지 내 진화 버튼으로 ‘진화’ 가능합니다.
& 일부 특수 진화 조건을 가진 포켓몬은 차후 공지로 따로 안내될 예정입니다.


### 기술
& 일반적으로 레벨에 따라 기술을 습득하며 이전에 배웠던 기술이라면 언제든 떠올리거나 잊게 할 수 있습니다.
& 알 기술, 가르침 기술, 기술 머신 기술은 특정 주차에 해금될 예정이며 추후 프렌들리 샵을 통해 관련 도구 구매로 기술 습득이 가능합니다.

### 기초 포인트
& 포켓몬의 능력치에 영향을 미치는 값으로 배틀에서는 비욘드 난이도에만 적용되어 필수로 고려되는 선택지가 아닙니다.
& 특정 주차부터 관련 도구를 통해 분배가 가능합니다.

### 컨디션
& 콘테스트에서 사용되는 능력으로 [귀여움 / 근사함 / 강인함 / 슬기로움 / 아름다움] 총 5종류의 능력이 있습니다.
& 관련 도구를 통해 상승이 가능합니다.

## 배틀
& 배틀은 오픈 카카오톡에서 실시간으로 진행되며 담당 스텝이 수동으로 계산합니다. 또한 실전 배틀이 익숙하지 않은 러너분들을 위한 전용 룰이 존재합니다. 
& 모든 포켓몬의 개체값은 6V로 고정됩니다.
& 그외 모든 배틀 판정은 ==9세대 실전 배틀 기준==으로 하고 있습니다.

![level](/img/notice/level.png =700)

## 체육관
& 특정 주차를 제외하고 매주 금·토 저녁 / 일요일 오전까지 원하는 시간대에 체육관에 도전할 수 있습니다. 
& 첫 번째, 두 번째 체육관까지는 오리진 난이도로만 진행 후, 세 번째 체육관부터 비욘드 난이도가 해금됩니다. 보상의 차이는 없으며 난이도 비교 언급은 메타 발언으로 간주합니다.
& 8개의 배지를 모았을 시 포켓몬 리그 도전 가능 자격이 부여됩니다.

## 친선전
& 러너 간 PVP 친목 배틀로 커뮤 내 일정 상황을 고려하여 게릴라성 이벤트로 진행되며 1주 전 공지됩니다. 
& 희망자 한해서만 진행되며 러너간 합의된 규칙으로 배틀이 이뤄집니다.

## 콘테스트
### 기본 규칙
& 오메가루비·알파사파이어 콘테스트 라이브 룰을 참고하였으며, 매주 일요일 저녁, 러너 간 PVP 형식으로 두 타임 나뉘어 진행되어 우승자는 체육관 ‘배지’에 해당하는 ‘리본’을 획득하게 됩니다.
& 콘테스트 타입은 [불/물/풀…] 등등이 아닌 ==[귀여움 / 근사함 / 강인함 / 슬기로움 / 아름다움]== 5종으로 지칭됩니다.
& 진행은 1마리  포켓몬만 출전할 수 있습니다.

### 기술
& 콘테스트에서는 배틀과는 다른 효과를 지닙니다.
& 효과 및 콤보 기술 조합은 해당 사이트를 참고로 하고 있습니다. [기술 효과](https://podic.kr/Gen6/move_list_type-clever.html) · [콤보 기술 조합](https://pokemon.fandom.com/ko/wiki/%EC%BD%98%ED%85%8C%EC%8A%A4%ED%8A%B8_%EC%97%B0%EC%86%8D_%EC%BD%A4%EB%B3%B4)

## 메가진화
특정 주차이후 엔트리 내 포켓몬의 메가진화가 해금되며 체육관 관장NPC의 엔트리에도 적용됩니다.

### 통상의 메가진화
& 6월 30일 기준으로, 기존 메가진화를 포함해 포켓몬 챔피언스에 입국한 포켓몬들의 메가진화가 가능합니다. 단, 메가진화 시의 특성, 종족값만 적용되며, 배우는 기술·위력 및 부가 효과 등은 9세대를 기준으로 합니다. 
&  메가진화 가능 조건
** 포켓몬에 맞는 메가스톤 소지
** 친밀도 200
### 파트너 포켓몬의 메가진화
& 스토리 진행 중 파트너 포켓몬의 메가진화가 가능해집니다. 이는 기존에 알려진 통상의 메가진화가 아닌 ‘메가진화■■’로 명칭됩니다. 
& 러너는 자유롭게 메가진화■■ 폼을 설정할 수 있으며, 러닝 중 구글폼을 통해 제출할 예정입니다. 
& 메가진화■■ 설정 제출 사항
** 메가진화 폼 (통상의 메가진화 이미지 제출 가능) 
** 기존 종족값 총합에서 100 상승된 범위 내 투자 
** 메가진화 특성 (창작 가능)
& 단, 커뮤니티 내 배틀 밸런스를 위해 일부 메가진화 설정은 조율이 요청될 수 있습니다. 

{br:60}
<> 모든 시스템의 이용 가이드는 합격자 발표 후 안내될 예정입니다.


%% ⓒ2026 · 포켓몬스터 오리진 비욘드`;